<template>
  <section>
    <div class="">
      <div class="container">
        <ul class="mypage_header">
          <li class="mypage_menu">MY 팝콘</li>
          <li class="mypage_menu"> <span class="title">관심<br>파트너스</span>  <div class="spec"> {{parteners_count}} <span class="content">개</span></div> </li>
          <li class="mypage_menu"> <span class="title">관심<br>서비스</span>  <div class="spec"> {{service_count}} <span class="content">장</span></div> </li>
          <li class="mypage_menu"> <span class="title" style="line-height:44px;">프로젝트</span> <div class="spec"> {{project_count}} <span class="content"></span></div> </li>
          <li class="mypage_menu">
            <div class="sub_menu"><span class="title"> 커뮤니티</span> <div class="spec"> {{community_count}} <span class="content">건</span></div> </div>
            <div class="sub_menu"> <span class="title">포인트</span> <div class="spec"> 0 <span class="content">점</span></div> </div>
          </li>
          <!-- <li @click="$router.push('/mypage/account')" class="mypage_menu">계정 설정</li> -->
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data(){
    return{
      "parteners_count":0,
      "service_count":0,
      "project_count":0,
      "community_count":0
    }
  },
  mounted(){
    this.$http.post("app/get_mypage_summary").then(res=>{
      this.parteners_count = res.data.parteners_count
      this.service_count = res.data.service_count
      this.project_count = res.data.project_count
      this.community_count = res.data.community_count
    })
  },
};
</script>

<style scoped lang="scss">
.mypage_header{
  width:1100px;
  margin: 20px auto;
  .mypage_menu{
    float: left;
    width: 150px;
    height: 120px;
    background-color: #82bce2;
    padding-left:30px;
    color:#fff;    
    border-right: 1px solid #9bc9e8;
    border-left: 1px solid #78add0;
    font-size: 15px;
    text-shadow: 0 1px 0 rgba(0,0,0,0.2);
    .title{
      display: block;
      margin-top:8px;
      height: 44px;
    }
    .spec{
      font-size: 50px;
      .content{
        font-size: 12px;
      }
    }
    .sub_menu:last-child{
      border-top: 1px solid #9bc9e8;
      border-bottom: none;
    }
    .sub_menu{
      height: 60px;
      line-height: 60px;
      position: relative;
      border-top: 1px solid #9bc9e8;
      border-bottom: 1px solid #78add0;
      padding-left:30px;
      .title{
        display: inline-block;
        margin-top: 0px;
        font-size: 15px;
        text-shadow: 0 1px 0 rgba(0,0,0,0.2);
        vertical-align: top;
      
      }
      .spec{
        display: inline-block;
        vertical-align: sub;
        font-size: 28px;
        vertical-align: top;
        position: absolute;
        right: 15px;
        .content{
          font-size: 12px;
          vertical-align: unset;

        }
      } 
    }
  }
  .mypage_menu:nth-child(1){
    float: left;
    width: 160px;
    height: 120px;
    background: #286db4;
    text-align: center;
    color:#fff;
    line-height: 120px;
    border-right: none;
    border-left: none;
    font-size: 30px;
    padding-left: 0px;
  }
   .mypage_menu:nth-child(5){
    float: left;
    width: 488px;
    height: 120px;
    background: #82bce2;
    color:#fff;
    line-height: 120px;
    border-right: none;
    border-left: none;
    font-size: 30px;
    padding-left:0px;
  }

}
</style>



// WEBPACK FOOTER //
// src/SharedComponents/MyPageHeader.vue